export const actions = {
  set_state: 'setting_qr/set_state',
  delete_setting_qr: 'setting_qr/delete_setting_qr',
  update_setting_qr: 'setting_qr/update_setting_qr',
  upload_setting_qr: 'setting_qr/upload_setting_qr',
  create_setting_qr: 'setting_qr/create_setting_qr',
  get_setting_qr: 'setting_qr/get_setting_qr'
}
